import { I18nProvider } from '@atlas-ui/locale';
import type { Locales } from '@atlas-ui/locale';
import type { PropsWithChildren } from 'react';
import { createContext, useMemo } from 'react';
import { TokensGlobalStyle } from './styles/TokensGlobalStyle';

export interface AtlasProviderOwnProps {
  locale?: Locales;
  withoutDeprecationWarnings?: boolean;
}

export type AtlasProviderProps = PropsWithChildren<AtlasProviderOwnProps>;

export const AtlasProviderContext = createContext({
  withoutDeprecationWarnings: false,
});

export const AtlasProvider = ({
  children,
  locale,
  withoutDeprecationWarnings = false,
}: AtlasProviderProps) => {
  const providerValue = useMemo(() => {
    return { withoutDeprecationWarnings };
  }, [withoutDeprecationWarnings]);

  return (
    <>
      <TokensGlobalStyle />
      <I18nProvider locale={locale}>
        <AtlasProviderContext.Provider value={providerValue}>
          {children}
        </AtlasProviderContext.Provider>
      </I18nProvider>
    </>
  );
};
